import { BaseLayout } from "layouts/base.layout";
import { BrowserRouter } from "react-router-dom";
import { BaseRoute } from "routes/base.route";
import { WebAppProvider } from "@vkruglikov/react-telegram-web-app";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <WebAppProvider options={{ smoothButtonsTransition: true }}>
      <BaseLayout>
        <BrowserRouter>
          <BaseRoute />
          <ToastContainer theme="colored" />
        </BrowserRouter>
      </BaseLayout>
    </WebAppProvider>
  );
}

export default App;
